import { isNumber } from "lodash";

/**
 * Checks the current `url` is or is not a external url which is determined if the url starts with `http` or `https`.
 * @param url The url to test.
 * @returns True if the URL is an external link, otherwise false.
 */
export function isExternal(url: string | number): boolean {
  if (!isNumber(url)) {
    if (url && (url.indexOf("http://") === 0 || url.indexOf("https://") === 0)) {
      return true;
    }
  }

  return false;
}
